import React, { Component } from "react";
import ReactPlayer from 'react-player'
import {
	MuiGrid,
	MuiIconButton,
	MuiAddCircle,
	MuiTypography,
	MuiFab,
	MuiMoreVertIcon,
	MuiPersonAdd
} from "../../ui/MaterialUIComponents";
import theme from "../../../assests/theme";
import spinner from "../../ui/icons/spinner.gif";
import { Link } from "react-router-dom";
import routes from "../../navigation/Routes";
import { SchoolListComponent } from ".";
import { StepperUtil } from "../../functional/school";
import * as Constants from '../../../constants';
import {removeDataInLS} from '../../../utils/LocalStorageUtil'
import {saveSchoolConcurrently} from '../../../utils/ConcurrentSchoolSaveUtil';
export class DashBoard extends Component {
	constructor(props) {
		super(props);

		this.state = {
			schoolList: this.props.schoolList
		};
	}

	componentWillMount() {
		removeDataInLS(Constants.STEPPER_STATE_KEY_LS);
		if (this.props.userInformation.profiles[0].profileType === "OWNER") {
			this.props.getSchoolInfromation(this.props.userInformation._id);
		}
		else {
			this.props.getSchoolInformationByAdminId(1, this.props.userInformation._id)
		}
	}
	onClickOfAddMoreSchools = () => {
		window.location.href = `/#${routes.addSchool}`;
	};

	deleteSchool = async (school, index) => {

		let schoolList = this.state.schoolList;
		school.isArchived = true;
		let removed = schoolList.splice(index, 1);
		let result = await saveSchoolConcurrently(this.props.editSchoolInformation,
			this.props.userInformation._id, 
			school._id, 
			school,
			"School Deleted Successfully")
		if(result.success){
			this.setState({
				schoolList: schoolList
			});
		}else{
			school.isArchived = false;
			schoolList.splice(index, 0, ...removed);
		}
		
	};
	render() {
		let schoolList = this.props.schoolList;
		let userProfile = this.props.userInformation.profiles[0].profileType;

		return (
			<MuiGrid container>
				{this.props.getSchoolInformationInProgress == true && (
					<img
						src={spinner}
						alt="none"
						style={theme.spinnerImgStyle}
					/>
				)}
				{schoolList.length > 0 && schoolList.map((school, index) => {
					if (school.isArchived == false) {
						return (
							<SchoolListComponent
								school={school}
								index={index}
								deleteSchool={this.deleteSchool}
								{...this.props}
							/>
						)
					}
				})}

				<br />
				{userProfile === "OWNER" && (
					<MuiGrid
						conatiner
						xs={12}
						align="center"//onClick={() => this.onClickOfAddMoreSchools()}
					>
						<MuiGrid
							container
							xs={8}
							style={theme.borderForGrid}
							justify="center"
							alignItems="center"
						>
							<MuiGrid
								item
								style={theme.gridActionContainerStyle}
							>
								<Link
									to={{
										pathname: routes.addSchool,
									}}
								>

									<MuiAddCircle style={{ color: theme.palette.orange }} fontSize='large' />

									<br />
								</Link>
							</MuiGrid >



							<MuiGrid item xs={2}>
								<MuiTypography
									variant={theme.typographyStyles.BODY1}
									color="primary"   >
									Add More Schools
								</MuiTypography>
							</MuiGrid>


						</MuiGrid>
						<br />
					</MuiGrid>
				)}
				{schoolList.length < 0 &&
					<ReactPlayer url='https://www.youtube.com/watch?v=zAj8QECaCVM' playing width="40%" height="70%" />
				}
			</MuiGrid>
		);
	}
}

export default DashBoard;
